module.exports = __webpack_public_path__ + "static/media/d_product_guide.1fe04bfc.png";